module.exports = "<div class=\"cookies-infos\">\n    <div *ngFor=\"let info of cookiesInformations\">\n        <div *ngIf=\"info.type !== 'tarteaucitronParameter'\" class=\"{{ info.type }}\">{{ info.content }}</div>\n        <button class=\"button default\" *ngIf=\"info.type === 'tarteaucitronParameter'\" (click)=\"openPanel()\">{{ info.content }}</button>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tarteaucitron/tarteaucitron.component.html
// module id = 542
// module chunks = 0